module.exports = __webpack_public_path__ + "img/img8.15f4dfe4.svg";